// Design system centralisé pour EpSessionV2
// Toutes les couleurs, gradients et styles récurrents sont définis ici.

export const colors = {
  text: {
    primary: "#1e293b",
    secondary: "#475569",
    muted: "#94a3b8",
    link: "#2563eb",
    white: "#fff",
  },
  border: {
    default: "#e2e8f0",
    light: "#f1f5f9",
  },
  bg: {
    white: "#fff",
    page: "#f8fafc",
  },
  success: {
    bg: "#f0fdf4",
    border: "#86efac",
    text: "#166534",
    dark: "#16a34a",
  },
  warning: {
    bg: "#fefce8",
    border: "#fde68a",
    text: "#92400e",
    light: "#fef3c7",
  },
  danger: {
    bg: "#fef2f2",
    border: "#fca5a5",
    text: "#991b1b",
  },
  info: {
    bg: "#eef2ff",
    border: "#c7d2fe",
    text: "#3730a3",
  },
  primary: {
    main: "#2563eb",
    dark: "#1d4ed8",
    light: "#93c5fd",
    bg: "#eff6ff",
    border: "#3b82f6",
  },
};

export const gradients = {
  primary: "linear-gradient(135deg, #2563eb, #1d4ed8)",
  header: "linear-gradient(135deg, #1e3a5f 0%, #2563eb 100%)",
  success: "linear-gradient(135deg, #22c55e, #16a34a)",
  warning: "linear-gradient(135deg, #f59e0b, #d97706)",
  danger: "linear-gradient(135deg, #ef4444, #dc2626)",
  indigo: "linear-gradient(135deg, #6366f1, #4f46e5)",
  sky: "linear-gradient(135deg, #0ea5e9, #0284c7)",
  progressComplete: "linear-gradient(90deg, #22c55e, #16a34a)",
  progressActive: "linear-gradient(90deg, #3b82f6, #2563eb)",
};

export const typography = {
  label: {
    fontSize: 11,
    fontWeight: 700,
    color: colors.text.muted,
    textTransform: "uppercase",
    letterSpacing: 0.5,
  },
  value: {
    fontSize: 14,
    fontWeight: 600,
    color: colors.text.primary,
  },
  heading: {
    fontSize: 18,
    fontWeight: 700,
    color: colors.text.primary,
  },
  small: {
    fontSize: 13,
    color: colors.text.secondary,
  },
  tiny: {
    fontSize: 12,
    color: colors.text.muted,
  },
};

export const iconBox = (size, background) => ({
  width: size,
  height: size,
  borderRadius: size <= 32 ? 6 : 8,
  background,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
});

export const transition = "all 0.2s ease";

export const card = {
  background: colors.bg.white,
  border: `1px solid ${colors.border.default}`,
  borderRadius: 8,
};

export const alertBox = (variant = "warning") => ({
  padding: "12px",
  borderRadius: 8,
  fontSize: 13,
  background: colors[variant].bg,
  border: `1px solid ${colors[variant].border}`,
  color: colors[variant].text,
});

export const btnBase = {
  borderRadius: 8,
  fontSize: 13,
  fontWeight: 700,
  transition,
  border: "none",
};
